var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-overlay",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.closeOverlay($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal",
          on: {
            click: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
            }
          }
        },
        [
          _c("img", {
            staticClass: "close-button",
            attrs: {
              src: "/site_media/version-0/images/course-page/close.svg",
              alt: "Close"
            },
            on: { click: _vm.closeOverlay }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.course.name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _vm._v("\n      " + _vm._s(_vm.course.intro_text) + "\n    ")
          ]),
          _vm._v(" "),
          _vm.course.course_map
            ? _c("ModalCourseMap", {
                attrs: {
                  prerequisites: _vm.course.course_map.prerequisites,
                  nextSteps: _vm.course.course_map.next_steps
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }